import React from 'react';
import { useTranslation } from 'react-i18next';
import './StationSelector.css';

const StationSelector = ({ stations, selected, onChange }) => {
  const { t } = useTranslation();

  if (!stations || stations.length === 0) {
    return (
      <div className="station-selector">
        <span className="station-selector__label">{t('kitchen.noStations')}</span>
      </div>
    );
  }

  const toggle = (id) => {
    const next = selected.includes(id)
      ? selected.filter((s) => s !== id)
      : [...selected, id];
    onChange(next);
  };

  const selectAll = () => onChange(stations.map((s) => s.id));
  const clearAll = () => onChange([]);

  return (
    <div className="station-selector">
      <span className="station-selector__label">{t('kitchen.stations')}</span>
      <div className="station-selector__chips">
        {stations.map((station) => (
          <button
            key={station.id}
            type="button"
            className={`station-selector__chip ${selected.includes(station.id) ? 'station-selector__chip--active' : ''}`}
            style={{
              borderColor: station.color_hex || '#10B981',
              backgroundColor: selected.includes(station.id) ? (station.color_hex || '#10B981') : 'transparent'
            }}
            onClick={() => toggle(station.id)}
          >
            {station.name}
          </button>
        ))}
      </div>
      <button type="button" className="station-selector__all" onClick={selectAll}>
        {t('kitchen.all')}
      </button>
      <button type="button" className="station-selector__clear" onClick={clearAll}>
        {t('kitchen.clear')}
      </button>
    </div>
  );
};

export default StationSelector;
